module.exports = __webpack_public_path__ + "static/media/icon_medical.099408ae.svg";